// Dismisses the startup screen drawn by public/index.html (installed app only).
// No-op in a normal browser tab, in tests, and when already dismissed.
export function hideSplash() {
  try {
    const splash = typeof window !== 'undefined' ? window.__ridaloSplash : null;
    if (splash && typeof splash.hide === 'function') splash.hide();
  } catch (e) {
    /* the startup screen must never break the app */
  }
}
